if (!Element.prototype.matches) {
	Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
}

class util {
	static addClass(_element, className) {
		if (_element.classList) {
			_element.classList.add(className);
		} else if (!this.hasClass(_element, className)) {
			_element.className += ` ${className}`;
		}
	}
	
	static addEventListenerOnce(_element, event, fn) {
		function func() {
			_element.removeEventListener(event, func);
			fn.apply(this, arguments);
		}
		
		_element.addEventListener(event, func);
	}
	
	static ajax(url, { contentType = true, crossDomain = false, data = '', method = 'GET', onerror, onloadstart, onloadend, onprogress, onsuccess } = {}) {
		method = method.toUpperCase();
		
		let xhr = new XMLHttpRequest();
		
		if (!crossDomain || 'withCredentials' in xhr) {
			xhr.open(method, url + (method === 'GET' && data ? `?${data}` : ''), true);
		} else if (typeof XDomainRequest !== 'undefined') {
			xhr = new XDomainRequest();
			xhr.open(method, url + (method === 'GET' && data ? `?${data}` : ''));
		} else {
			return;
		}
		
		xhr.onload = () => {
			let response;
			
			try {
				response = JSON.parse(xhr.responseText);
			} catch (e) {
				response = xhr.responseText;
			}
			
			if (xhr.status === 200 && response.redirect) {
				window.location.href = response.redirect;
				return;
			}
			
			if (xhr.status === 200 && onsuccess) {
				onsuccess(response);
			} else if (xhr.status !== 200 && onerror) {
				onerror(response);
			}
		};
		
		if (onloadstart) {
			xhr.onloadstart = () => onloadstart();
		}
		
		if (onloadend) {
			xhr.onloadend = () => onloadend();
		}
		
		if (onprogress) {
			xhr.onprogress = (event) => onprogress(event);
		}
		
		if (onerror) {
			xhr.onerror = () => onerror();
		}
		
		if (!crossDomain) {
			xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
		}
		
		if (method === 'POST' && contentType) {
			xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
		}
		
		xhr.send(method === 'POST' ? data : '');
	}
	
	static convertPxToRem(px) {
		if ('getComputedStyle' in window) {
			return px / parseFloat(getComputedStyle(document.documentElement).fontSize);
		}
		
		return px / 16;
	}
	
	static convertRemToPx(rem) {
		if ('getComputedStyle' in window) {
			return rem * parseFloat(getComputedStyle(document.documentElement).fontSize);
		}
		
		return rem * 16;
	}
	
	static closest(_element, selector, ancestorsOnly = false) {
		if (ancestorsOnly) {
			_element = _element.parentNode;
		}
		
		while (_element && 'matches' in _element) {
			if (_element.matches(selector)) {
				return _element;
			}
			
			_element = _element.parentNode;
		}
		
		return null;
	}
	
	static closestParent(_element, selector) {
		return this.closest(_element, selector, true);
	}
	
	static debounce(func, delay) {
		let timeout;
		
		return function () {
			const context = this,
				args = arguments;
				
			clearTimeout(timeout);
			timeout = setTimeout(function () { func.apply(context, args); }, delay);
		};
	}
	
	static elementIndex(_element) {
		let index = -1;
		
		do {
			_element = _element.previousElementSibling;
			index++;
		} while (_element);
		
		return index;
	}
	
	static elementPosition(_element) {
		const bounding = _element.getBoundingClientRect();
		
		return {
			x: bounding.left + parseInt(window.pageXOffset || document.documentElement.scrollLeft),
			y: bounding.top + parseInt(window.pageYOffset || document.documentElement.scrollTop)
		};
	}
	
	static hasClass(_element, className) {
		if (_element.classList) {
			return _element.classList.contains(className);
		} else {
			return !!_element.className.match(new RegExp(`(\\s|^)${className}(\\s|$)`));
		}
	}
	
	static hasParent(_element, _searchedParent) {
		if (!_searchedParent) {
			return false;
		}
		
		do {
			_element = _element.parentNode;
			
			if (_element === _searchedParent) {
				return true;
			}
		} while (_element);
		
		return false;
	}
	
	static removeClass(_element, className) {
		if (_element.classList) {
			_element.classList.remove(className);
		} else if (this.hasClass(_element, className)) {
			_element.className = _element.className.replace(new RegExp(`(\\s|^)${className}(\\s|$)`), ' ');
		}
	}
	
	static scrollBefore(_element, duration = 800, speed = 'fast', callback) {
		this.scrollTo(this.elementPosition(_element).y - 30, duration, callback);
	}
	
	static scrollTo(destination, duration = 800, speed = 'fast', callback) {
		const animation = window.requestAnimationFrame || window.webkitRequestAnimationFrame || function (callback) { setTimeout(callback, 1000 / 60); };
		const destinationOffset = (typeof destination === 'number' ? destination : this.elementPosition(destination).y);
		const documentHeight = Math.max(document.body.scrollHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight);
		const start = parseInt(window.pageYOffset || document.documentElement.scrollTop);
		const startTime = ('now' in window.performance ? performance.now() : new Date().getTime());
		const windowHeight = window.innerHeight || document.documentElement.clientHeight;
		const destinationOffsetToScroll = Math.round(documentHeight - destinationOffset < windowHeight ? documentHeight - windowHeight : destinationOffset);
		
		function scroll() {
			const now = ('now' in window.performance ? performance.now() : new Date().getTime());
			let time = Math.min(1, ((now - startTime) / duration));
			let easing;
			
			if (speed === 'fast') {
				easing = (time < 0.5 ? 2 * time * time : -1 + (4 - 2 * time) * time);
			} else {
				easing = (time < 0.5 ? 16 * time * time * time * time * time : 1 + 16 * (--time) * time * time * time * time);
			}
			
			window.scroll(0, Math.ceil((easing * (destinationOffsetToScroll - start)) + start));
			
			if (parseInt(window.pageYOffset || document.documentElement.scrollTop) === destinationOffsetToScroll) {
				if (callback) {
					callback();
				}
				
				return;
			}
			
			animation(scroll);
		}
		
		scroll();
	}
	
	static serializeForm(_form) {
		if (typeof _form !== 'object' || _form.nodeName !== 'FORM') {
			return '';
		}
		
		let _field;
		const params = [];
		
		for (let i = 0, length = _form.elements.length; i < length; i++) {
			_field = _form.elements[i];
			
			if (_field.name && !_field.disabled && _field.type !== 'file') {
				if (_field.type === 'select-multiple') {
					for (let j = 0, optionsLength = _form.elements[i].options.length; j < optionsLength; j++) {
						if (_field.options[j].selected) {
							params.push(`${encodeURIComponent(_field.name)}=${encodeURIComponent(_field.options[j].value)}`);
						}
					}
				} else if ((_field.type !== 'checkbox' && _field.type !== 'radio') || _field.checked) {
					params.push(`${encodeURIComponent(_field.name)}=${encodeURIComponent(_field.value)}`);
				}
			}
		}
		
		return params.join('&').replace(/%20/g, '+');
	}
	
	static toggleClass(_element, className) {
		if (this.hasClass(_element, className)) {
			this.removeClass(_element, className);
		} else {
			this.addClass(_element, className);
		}
	}
	
	static triggerEvent(_element, event) {
		if ('createEvent' in document) {
			const evt = document.createEvent('HTMLEvents');
			evt.initEvent(event, true, true);
			_element.dispatchEvent(evt);
		} else {
			_element.fireEvent(`on${event}`);
		}
	}
}

class FormValidator {
	constructor(_form, { ajaxSubmit = true, errorMode = 'inner', onaftersubmit, onbeforesubmit, onerror, onsuccess, resetAfterSubmit = false, submitText = '' } = {}) {
		this.ajaxSubmit = ajaxSubmit;
		this.errorMode = errorMode;
		this.onaftersubmit = onaftersubmit;
		this.onbeforesubmit = onbeforesubmit;
		this.onerror = onerror;
		this.onsuccess = onsuccess;
		this.resetAfterSubmit = resetAfterSubmit;
		this.submitText = submitText;
		this.submitting = false;
		
		this._form = _form;
		this._recaptchaField = _form.querySelector('.g-recaptcha');
		this._submitButtons = _form.querySelectorAll('[type="submit"]');
		
		if (this.submitText) {
			this.originalSubmitTexts = [];
			
			for (let i = 0, length = this._submitButtons.length; i < length; i++) {
				this.originalSubmitTexts[i] = this._submitButtons[i].innerHTML;
			}
		}
		
		this.submitEvent = this.submit.bind(this);
		
		this.attachSubmitEvent();
	}
	
	attachSubmitEvent() {
		this._form.addEventListener('submit', this.submitEvent);
	}
	
	detachSubmitEvent() {
		this._form.removeEventListener('submit', this.submitEvent);
	}
	
	disableSubmitButtons() {
		for (let i = 0, length = this._submitButtons.length; i < length; i++) {
			this._submitButtons[i].disabled = true;
			
			if (this.submitText) {
				this._submitButtons[i].innerHTML = this.submitText;
			}
		}
	}
	
	enableSubmitButtons() {
		for (let i = 0, length = this._submitButtons.length; i < length; i++) {
			this._submitButtons[i].disabled = false;
			
			if (this.submitText) {
				this._submitButtons[i].innerHTML = this.originalSubmitTexts[i];
			}
		}
	}
	
	errorFieldChange(_field) {
		_field.removeAttribute('aria-invalid');
		util.removeClass(_field, 'is-invalid');
		
		const _errorMessage = _field.nextElementSibling;
		
		if (_errorMessage && util.hasClass(_errorMessage, 'error-message')) {
			_errorMessage.parentNode.removeChild(_errorMessage);
		}
	}
	
	hideErrorsAndMessages() {
		const _errorFields = this._form.querySelectorAll('.is-invalid');
		
		for (let i = 0, length = _errorFields.length; i < length; i++) {
			_errorFields[i].removeAttribute('aria-invalid');
			util.removeClass(_errorFields[i], 'is-invalid');
		}
		
		if (this.errorMode === 'inner') {
			const _errorMessages = this._form.querySelectorAll('.error-message--inside');
			
			for (let i = 0, length = _errorMessages.length; i < length; i++) {
				_errorMessages[i].parentNode.removeChild(_errorMessages[i]);
			}
		}
		
		const _outerErrorMessage = this._form.querySelector('.error-message--outside');
		
		if (_outerErrorMessage) {
			_outerErrorMessage.parentNode.removeChild(_outerErrorMessage);
		}
	}
	
	showOuterErrorMessage(errors) {
		let message = '';
		
		for (let i = 0, length = errors.length; i < length; i++) {
			message += `${errors[i]}<br>`;
		}
		
		const _outerErrorMessage = document.createElement('div');
		_outerErrorMessage.className = 'error-message error-message--outside';
		_outerErrorMessage.setAttribute('role', 'alert');
		_outerErrorMessage.innerHTML = message;
		
		this._form.insertBefore(_outerErrorMessage, this._form.firstChild);
		
		util.scrollBefore(_outerErrorMessage);
	}
	
	submit(event) {
		event.preventDefault();
		
		if (this.submitting) {
			return;
		}
		
		this.submitting = true;
		
		this.disableSubmitButtons();
		this.hideErrorsAndMessages();
		
		if (this.onbeforesubmit) {
			this.onbeforesubmit();
		}
		
		util.ajax(this._form.action, {
			data: util.serializeForm(this._form),
			method: this._form.method || 'POST',
			
			onsuccess: (response) => {
				this.enableSubmitButtons();
				
				if (!response.errors) {
					if (!this.ajaxSubmit) {
						this._form.submit();
					} else if (this.resetAfterSubmit) {
						this._form.reset();
					}
					
					if (this.onsuccess) {
						this.onsuccess(response);
					}
				} else {
					const outerErrorMessages = (this.errorMode === 'outer' ? response.errors : []);
					let _errorField;
					let _element;
					let focused = false;
					
					for (let i = 0, length = response.errors.length; i < length; i++) {
						if (response.errors[i].field && (_errorField = this._form.elements.namedItem(response.errors[i].field)) && _errorField.type) {
							_errorField.setAttribute('aria-invalid', true);
							util.addClass(_errorField, 'is-invalid');
							util.addEventListenerOnce(_errorField, 'change', this.errorFieldChange.bind(this, _errorField));
							
							if (!focused) {
								_errorField.focus();
								focused = true;
							}
							
							if (this.errorMode === 'inner') {
								_element = document.createElement('div');
								_element.className = 'error-message error-message--inside';
								_element.setAttribute('role', 'alert');
								_element.appendChild(document.createTextNode(response.errors[i].message));
								
								_errorField.parentNode.insertBefore(_element, _errorField.nextSibling);
							}
						} else if (this.errorMode === 'inner') {
							outerErrorMessages.push(response.errors[i].message);
						}
					}
					
					if (this.errorMode === 'alert') {
						flashMessage.show('error', response.errors[0].message);
						/*let message = '';
						
						for (let i = 0, length = response.errors.length; i < length; i++) {
							message += `${response.errors[i].message}\n`;
						}
						
						alert(message);*/
					} else if (outerErrorMessages.length > 0) {
						this.showOuterErrorMessage(outerErrorMessages);
					} else {
						util.scrollTo(util.elementPosition(this._form.querySelector('.is-invalid')).y - 100);
						setTimeout(() => this._form.querySelector('.is-invalid').focus(), 350);
					}
					
					if (this.onerror) {
						this.onerror();
					}
				}
				
				if (this._recaptchaField) {
					recaptchaExecute(this._recaptchaField);
				}
			},
			
			onerror: () => {
				if (this.onerror) {
					this.onerror();
				}
			},
			
			onloadend: () => {
				this.submitting = false;
				
				if (this.onaftersubmit) {
					this.onaftersubmit();
				}
			}
		});
	}
}

(function () {
	const _forms = document.querySelectorAll('[data-ajax-validation]');
	
	for (let i = 0, length = _forms.length; i < length; i++) {
		const params = _forms[i].getAttribute('data-ajax-validation');
		new FormValidator(_forms[i], (params !== '' && params !== 'data-ajax-validation' ? JSON.parse(params) : {}));
	}
}());

window.addEventListener('DOMContentLoaded', () => {
	util.addClass(document.documentElement, 'dom-ready');
});

window.addEventListener('load', () => {
	util.removeClass(document.documentElement, 'page-loading');
	util.addClass(document.documentElement, 'page-loaded');
});

if ('ontouchstart' in window || navigator.msMaxTouchPoints) {
	util.addClass(document.documentElement, 'touch');
}

(function () {
	let keyPressed = false;
	
	document.addEventListener('keydown', () => keyPressed = true);
	document.addEventListener('keyup', () => keyPressed = false);
	
	document.addEventListener('focus', (event) => {
		if (keyPressed) {
			util.addClass(event.target, 'has-focus');
		}
	}, true);
	
	document.addEventListener('blur', (event) => util.removeClass(event.target, 'has-focus'), true);
}());

function _(text, params = {}, tags = []) {
	let translations = window[`${language}_translations`];
	
	if (typeof translations === 'undefined') {
		translations = {};
	}
	
	if (text in translations) {
		text = translations[text];
	}
	
	for (let key in params) {
		text = text.replace(`:${key}`, params[key]);
	}
	
	const regex = /<([^>]*)>/g;
	const originalText = text;
	let index = 0;
	let matches;
	
	while (matches = regex.exec(originalText)) {
		text = text.replace(matches[0], (tags[index] ? tags[index].replace('><', `>${matches[1]}<`) : matches[1]));
		index++;
	}
	
	return text;
}